import { h } from 'vue';

import { classNames } from '@components/utils';

import { ResizeObserver } from '../../../CdsTable/components/ResizeObserver';

import type { CSSProperties, FunctionalComponent, PropType, ShallowRef } from 'vue';

// @todo move from CdsTable to higher level?

interface FillerProps {
  ref?: ShallowRef<HTMLDivElement | undefined>;
  prefixCls?: string;
  /** Virtual filler height. Should be `count * itemMinHeight` */
  height: number;
  /** Set offset of visible items. Should be the top of start item position */
  offset?: number;
  onInnerResize?: () => void;
}

const Filler: FunctionalComponent<FillerProps> = ({ ref, height, offset, prefixCls, onInnerResize }, { slots }) => {
  let outerStyle = {};

  let innerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column'
  };

  if (offset !== undefined) {
    outerStyle = { height: `${height}px`, position: 'relative', overflow: 'hidden' };

    innerStyle = {
      ...innerStyle,
      transform: `translateY(${offset}px)`,
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0
    };
  }

  return h(
    'div',
    { ref, style: outerStyle },
    h(
      ResizeObserver,
      {
        onResize: ({ offsetHeight }) => {
          if (offsetHeight && onInnerResize) {
            onInnerResize();
          }
        }
      },
      {
        default: () =>
          h(
            'div',
            {
              style: innerStyle,
              class: classNames({
                [`${prefixCls}__holder-inner`]: prefixCls
              })
            },
            slots.default?.()
          )
      }
    )
  );
};

Filler.displayName = 'Filler';
Filler.inheritAttrs = false;
Filler.props = {
  prefixCls: String,
  /** Virtual filler height. Should be `count * itemMinHeight` */
  height: Number,
  /** Set offset of visible items. Should be the top of start item position */
  offset: Number,
  onInnerResize: Function as PropType<() => void>
};

export default Filler;
